import React from "react";
import "./listingVitals.css";
import { IconContext } from "react-icons";
import { IOpenHouseItem } from "../../lib";
import { MdDateRange } from "react-icons/md";

export enum EListingVitalsLayout {
  row1Border0 = "row1Border0",
  column1Border0 = "column1Border0",
  column1Border1 = "column1Border1",
  column1Border1Alt1 = "column1Border1Alt1",
  column1Border1Alt2 = "column1Border1Alt2",
  column2Border1 = "column2Border1",
  column2Border2 = "column2Border2",
  column2Border0 = "column2Border0",
  column2Column1Border1 = "column2Column1Border1",
}

export interface IListingOpenHouseProps {
  layout?: EListingVitalsLayout;
  className?: string;
  openHouse?: IOpenHouseItem[];
}

export const ListingOpenHouse: React.FC<IListingOpenHouseProps> = ({
  className,
  openHouse = []
}) => {

  let layoutVariant = {
    containerStyle: {},
    containerClasses: "",
    price: "",
    location: "",
    vitals: "",
  };

  const options:Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour:'numeric', minute:'numeric' };
  const optionsMinutes:Intl.DateTimeFormatOptions = { hour:'numeric', minute:'numeric' };

  

  return openHouse && openHouse.length > 0 ? (
    <IconContext.Provider
      value={{ size: "1.5em", className: "mr-1 inline align-bottom" }}
    >
      <div className={`bg-accent text-action-text p-3 listing-vitals grid text-composite-text ${layoutVariant.containerClasses} ${className}`} style={layoutVariant.containerStyle}>
        <span className="text-2xl font-bold text-center pb-2">
         {"Open House"}
        </span>
        {openHouse.map((item) => {
          const startDate = new Date(item.startDate);
          const endDate = new Date(item.endDate); //.toLocaleString('en-US', options);
          let text = startDate.toLocaleString('en-US', options) +" to ";
          if(endDate.getDate() === startDate.getDate()){
            text += endDate.toLocaleString('en-US', optionsMinutes);
          }else{
            text += endDate.toLocaleString('en-US', options);
          }
          return (
            <span><MdDateRange />{text}</span>
          )
        })}
      </div>
    </IconContext.Provider>
  ):(<></>);
};
